import { render } from "./meuCurriculo.vue?vue&type=template&id=08a953f5&scoped=true"
import script from "./meuCurriculo.vue?vue&type=script&lang=js"
export * from "./meuCurriculo.vue?vue&type=script&lang=js"

import "./meuCurriculo.vue?vue&type=style&index=0&id=08a953f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a953f5"]])

export default __exports__